<script>
    /*
    *  Goal: Sharing logic between route pages: (e.g: Discover, Browse, Licenses, About...)
    *  Every route page should include this mixin
    * */
    export default {
        name: "page",
        props: ['pageId'],
        mounted() {
            this.commitCurrentPage();
        },
        watch: {
            pageId() {
                this.commitCurrentPage();
            }
        },
        computed: {
            config() {
                return this.$store.state.currentConfig;
            },
            page() {
                return this.config.getPageById(this.pageId) || this.config.ge;
            }
        },
        methods: {
            commitCurrentPage() {
                if (this.page) {
                    this.$store.commit("currentPage", {page: this.page});
                }
            },
        }
    }
</script>
